import React, { useEffect, useState } from "react";
import { IonPage, IonContent, IonSpinner } from "@ionic/react";
import { useHistory } from "react-router-dom";
import { useAzureAuth } from './AzureAuthProvider';

/**
 * Componente para manejar el callback de Azure AD.
 * Este componente se renderiza en la ruta de redirección después de la autenticación con Azure AD.
 */
const AzureAuthCallback: React.FC = () => {
  const { isAuthenticated, userInfo } = useAzureAuth();
  const [error, setError] = useState<string | null>(null);
  const history = useHistory();

  useEffect(() => {
    // El manejo principal de la redirección lo hace el AzureAuthProvider
    // Este componente simplemente muestra un spinner y redirige cuando sea necesario
    if (error) {
      console.error("Error en el proceso de autenticación:", error);
      // En caso de error, redirigir al login
      setTimeout(() => history.replace('/login'), 3000);
    } else if (isAuthenticated && userInfo) {
      console.log("Usuario autenticado:", userInfo.username);
      // El redireccionamiento principal se maneja en AzureAuthProvider
      // Si llegamos aquí, es probablemente porque algo falló en la redirección automática
      setTimeout(() => history.replace('/'), 1500);
    }
  }, [error, isAuthenticated, userInfo, history]);

  return (
    <IonPage>
      <IonContent className="ion-padding ion-text-center">
        <div style={{ marginTop: '50%' }}>
          {error ? (
            <div>
              <h2>Error de Autenticación</h2>
              <p>{error}</p>
              <p>Redirigiendo al login...</p>
            </div>
          ) : (
            <>
              <IonSpinner name="circles" style={{ transform: 'scale(2)' }} />
              <h2 style={{ marginTop: '20px' }}>Procesando autenticación</h2>
              <p>Por favor espere...</p>
            </>
          )}
        </div>
      </IonContent>
    </IonPage>
  );
};

export default AzureAuthCallback;
